import React, { useEffect, useState } from "react";
import "../assets/css/login.css";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateCart } from "../redux/user/userSlice";

const ReplacementStatus = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(search);
  const replacementid = searchParams.get("replacementid");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="login">
      <div id="section1" className="container-fluid">
        {replacementid &&
          <div className="form">
            <h1 className="text-center">Request for Replacement Received</h1>
            <br />
            <p className="text-center">We have received your request for replacement. Please check your mail regularly for further updates.</p>
            <p className="text-center">Your replacement id is {replacementid}.</p>
            <br />
            <div className="d-grid gap-2">
              <Link to="/profile" className="btn whitebutton">
                View other orders
              </Link>
            </div>
          </div>
        }

        {!replacementid &&
          <div className="form">
            <h1 className="text-center">Request for Replacement Unsuccessfull</h1>
            <br />
            <p className="text-center">We could not process your request for replacement. Please try again later...</p>
            <br />
            <div className="d-grid gap-2">
              <Link to="/profile" className="btn whitebutton">
                View Orders
              </Link>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default ReplacementStatus;
